
import { Tooltip } from "@mantine/core";
import intl from "react-intl-universal";
import { useSelector } from "react-redux";
import { FilePencil, FileCheck } from 'tabler-icons-react';

/**
 * Generates the function tp display the status of a document a user have signed.
 *
 * @meetingParticipants {Object} - state.user.meetinguser - Array of Objects containing the user's meeting participants.
 * @meuser {Object} - state.user.meuser - The current user.  
 * @param {Object} props - The component props.
 * @param {string} props.resourceId - The ID of the resource to display.
 * @return {JSX.Element} the JSX element representing the UserSignDocStatus component
 */
const UserSignDocStatus = (props:any ) => {
   
   const meetingParticipants = useSelector((state: any) => state.user.meetinguser)
   const meuser = useSelector((state: any) => state.user.meuser)

   let doc_is_signed = false
   const meetingParticipantsstatus = meetingParticipants.filter((obj: {userId: any;}) => {
    return obj.userId === meuser.userId
   })

   const docstatus = meetingParticipantsstatus[0].documents.filter((obj: { resourceId: any; }) => {
    return obj.resourceId === props.resourceId
   })


   try {
      if (docstatus.length === 1) {
        doc_is_signed = docstatus[0].isSigned
      } else {
        throw new Error ("Status des Dokuments konnte nicht geladen werden");
      }
      } catch (e) {
      console.log(e);
      } finally {}

  

    return (
     <> 
       {!doc_is_signed && props.view !== "small" &&
         <Tooltip label={intl.get('USERSIGNDOCSATUS_NOTOK')} multiline={true}>
            <span>
               <FilePencil
                     size={30}
                     strokeWidth={1}
                     aria-label={props.docname}
                     />
            </span>
         </Tooltip> 
        }
       {doc_is_signed && props.view !== "small" &&
         <Tooltip label={intl.get('USERSIGNDOCSATUS_OK')} multiline={true}>
            <span>
               <FileCheck
                     size={30}
                     strokeWidth={1}
                     color="green"
                      aria-label={props.docname}
                        />
            </span>
         </Tooltip>
       }

      {!doc_is_signed && props.view === "small" &&
         <Tooltip label={intl.get('USERSIGNDOCSATUS_NOTOK')} multiline={true}>
            <span>
               <FilePencil
                     size={30}
                     strokeWidth={1}
                     aria-label={props.docname}
                     />
            </span>
         </Tooltip>
      }

      {doc_is_signed && props.view === "small" &&
        <Tooltip label={intl.get('USERSIGNDOCSATUS_OK')} multiline={true}>
            <span>
               <FileCheck
                     size={30}
                     strokeWidth={1}
                     color="green"
                     aria-label={props.docname}
                     />
            </span>
        </Tooltip>
       }
     </>
    )
};

export default UserSignDocStatus;